import {
    ChangeDetectionStrategy,
    Component,
    input,
    InputSignal,
    OnInit,
    output,
    OutputEmitterRef,
    signal,
} from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';

import { RessourcesModule } from '@ressources/client/ressources.module';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ReactiveFormsModule, RessourcesModule],
    selector: 'app-input-text',
    styleUrl: './input-text.component.scss',
    templateUrl: './input-text.component.html',
})
export class InputTextComponent implements OnInit {
    public readonly additionalClasses = input<string>('');
    public readonly disabled: InputSignal<boolean> = input<boolean>(false);
    public readonly errors: InputSignal<string[]> = input<string[]>([]);
    public readonly inputFormControl: InputSignal<FormControl | undefined> = input<FormControl | undefined>();
    public inputId: string = crypto.randomUUID();
    public readonly label: InputSignal<string | undefined> = input<string | undefined>();
    public readonly labelTooltip = input<string | undefined>();
    public readonly maxLength = input<number | undefined>();
    public onBlur: OutputEmitterRef<void> = output<void>();
    public onValueChange: OutputEmitterRef<string> = output<string>();
    public readonly placeholder: InputSignal<string | undefined> = input<string>();
    public readonly valueTooltip = input<string | undefined>();

    private readonly valueBlurOut = signal<string | undefined>(undefined);

    public handleOnBlur(): void {
        if (this.valueBlurOut() === this.inputFormControl()?.value) {
            return;
        }

        this.valueBlurOut.set(this.inputFormControl()?.value);
        this.onBlur.emit();
    }

    public ngOnInit(): void {
        this.valueBlurOut.set(this.inputFormControl()?.value);
    }

    public onChange(event: Event): void {
        this.onValueChange.emit((event.target as HTMLInputElement).value);
    }
}
